/* global Office */

const translations = {
  "en-GB": {
    // Prompt dialog
    "dialog.title": "Prompt Instructions",
    "dialog.description": "Edit the prompt below, then click Generate Reply.",
    "dialog.cancel": "Cancel",
    "dialog.submit": "Generate Reply",

    // Taskpane
    "settings.title": "Account",
    "settings.connectionTitle": "Connection",
    "settings.instanceLabel": "LibreChat instance",
    "settings.deploymentVersion": "Deployment version",
    "settings.manifestVersion": "Manifest version",
    "settings.connected": "Connected to LibreChat",
    "settings.notConfigured": "Not configured",
    "settings.refreshAgents": "Refresh agents",
    "settings.noAgentsFound": "Connected, but no agents found.",
    "settings.agentLabel": "Agent",
    "settings.agentDescription":
      "Choose which agent to use for generating responses.",
    "settings.agentPlaceholder": "-- Select an agent --",
    "taskpane.ribbonHint": "Use the ribbon buttons to interact with {app}.",
    "taskpane.promptLabel": "Prompt Instructions",
    "taskpane.generateReply": "Generate Reply",
    "taskpane.generatingReply": "Generating reply...",
    "taskpane.response": "Response",
    "taskpane.copyTooltip": "Copy to clipboard",
    "taskpane.loading": "Generating response\u2026",
    "taskpane.disclaimer":
      "Responses generated by this chat may contain inaccuracies — please verify them before use.",

    // Auth (Entra ID SSO)
    "auth.signedInAs": "Signed in as {0}",
    "auth.signingIn": "Signing you in…",
    "auth.signInRequired": "Please open the {app} task pane to sign in.",
    "auth.signInButton": "Sign in",
    "auth.signOut": "Sign out",
    "auth.accountTooltip": "Account",
    "auth.naaUnsupported":
      "This add-in needs a newer version of Outlook that supports single sign-on. Please update Outlook or use Outlook on the web.",
    "auth.failed": "Sign-in failed: ",
    "auth.identityMismatch":
      "You're signed in, but your account isn't linked to {app}. Contact your administrator.",

    // Tone rewrite
    "tone.pickHint": "Choose a tone for the selected text:",
    "tone.formal": "Formal",
    "tone.friendly": "Friendly",
    "tone.concise": "Concise",
    "tone.assertive": "Assertive",
    "tone.apply": "Apply to email",
    "tone.applied": "Tone applied to your email.",
    "tone.applyFailed": "Failed to apply the rewrite: ",
    "tone.noSelection":
      "Select some text in your email first, then choose a tone.",
    "tone.noSelectionApi":
      "Text selection isn't supported in this version of Outlook.",

    // Errors / messages (taskpane)
    "error.saveFailed": "Failed to save settings: ",
    "error.noEmail": "No email is currently selected.",
    "error.noSubject": "(No subject)",
    "error.noBody": "(Could not read email body)",
    "error.noBodyUpgrade":
      "(Could not read email body — upgrade Outlook for full support)",
    "error.noCompose": "No compose item is currently open.",
    "error.noComposeBody": "(Could not read compose body)",
    "error.noApiResponse": "No response content from API.",
    "error.unexpected": "An unexpected error occurred.",
    "error.signOutFailed": "Sign-out failed: ",
    "error.enterPrompt": "Please enter prompt instructions.",
    "error.readBody": "Failed to read compose body: ",
    "error.insertReply": "Failed to insert reply: ",
    "error.phishingBlocked":
      "Reply blocked: this email was flagged as a possible security threat. Review the summary in the task pane before acting.",
    "error.noReplyNeeded": "This email does not require a reply.",

    // Commands (notifications)
    "notify.signInRequired": "Please open the {app} task pane to sign in.",
    "notify.authFailed": "Sign-in failed: ",
    "notify.generating": "Generating AI reply...",
    "notify.replyFailed": "Reply failed: ",
    "notify.settingsError": "Failed to load settings. Please try again.",
    "notify.dialogError": "Failed to open instructions dialog: ",
    "notify.unexpectedError": "An unexpected error occurred in {app}: ",
    "notify.phishingBlocked":
      "Reply blocked: possible phishing detected. Open the task pane for details.",
    "notify.noReplyNeeded": "This email does not require a reply.",
  },
  "pt-PT": {
    // Prompt dialog
    "dialog.title": "Instruções do Prompt",
    "dialog.description": "Edite o prompt abaixo e clique em Gerar Resposta.",
    "dialog.cancel": "Cancelar",
    "dialog.submit": "Gerar Resposta",

    // Taskpane
    "settings.title": "Conta",
    "settings.connectionTitle": "Ligação",
    "settings.instanceLabel": "Instância do LibreChat",
    "settings.deploymentVersion": "Versão da implementação",
    "settings.manifestVersion": "Versão do manifesto",
    "settings.connected": "Ligado ao LibreChat",
    "settings.notConfigured": "Não configurado",
    "settings.refreshAgents": "Atualizar agentes",
    "settings.noAgentsFound": "Ligado, mas nenhum agente encontrado.",
    "settings.agentLabel": "Agente",
    "settings.agentDescription":
      "Escolha qual agente usar para gerar respostas.",
    "settings.agentPlaceholder": "-- Selecione um agente --",
    "taskpane.ribbonHint":
      "Utilize os botões do friso para interagir com o {app}.",
    "taskpane.promptLabel": "Instruções do Prompt",
    "taskpane.generateReply": "Gerar Resposta",
    "taskpane.generatingReply": "A gerar resposta...",
    "taskpane.response": "Resposta",
    "taskpane.copyTooltip": "Copiar para a área de transferência",
    "taskpane.loading": "A gerar resposta…",
    "taskpane.disclaimer":
      "As respostas geradas por este chat podem conter imprecisões, verifica-as antes de as utilizares.",

    // Auth (Entra ID SSO)
    "auth.signedInAs": "Sessão iniciada como {0}",
    "auth.signingIn": "A iniciar sessão…",
    "auth.signInRequired": "Abra o painel do {app} para iniciar sessão.",
    "auth.signInButton": "Iniciar sessão",
    "auth.signOut": "Terminar sessão",
    "auth.accountTooltip": "Conta",
    "auth.naaUnsupported":
      "Este suplemento precisa de uma versão mais recente do Outlook que suporte início de sessão único. Atualize o Outlook ou utilize o Outlook na Web.",
    "auth.failed": "Falha no início de sessão: ",
    "auth.identityMismatch":
      "Sessão iniciada, mas a sua conta não está associada ao {app}. Contacte o seu administrador.",

    // Tone rewrite
    "tone.pickHint": "Escolha um tom para o texto selecionado:",
    "tone.formal": "Formal",
    "tone.friendly": "Amigável",
    "tone.concise": "Conciso",
    "tone.assertive": "Assertivo",
    "tone.apply": "Aplicar ao e-mail",
    "tone.applied": "Tom aplicado ao seu e-mail.",
    "tone.applyFailed": "Falha ao aplicar a reescrita: ",
    "tone.noSelection":
      "Selecione primeiro algum texto no seu e-mail e depois escolha um tom.",
    "tone.noSelectionApi":
      "A seleção de texto não é suportada nesta versão do Outlook.",

    // Errors / messages (taskpane)
    "error.saveFailed": "Falha ao guardar definições: ",
    "error.noEmail": "Nenhum e-mail selecionado.",
    "error.noSubject": "(Sem assunto)",
    "error.noBody": "(Não foi possível ler o corpo do e-mail)",
    "error.noBodyUpgrade":
      "(Não foi possível ler o corpo do e-mail — atualize o Outlook para suporte completo)",
    "error.noCompose": "Nenhum item de composição aberto.",
    "error.noComposeBody": "(Não foi possível ler o corpo da composição)",
    "error.noApiResponse": "Sem conteúdo de resposta da API.",
    "error.unexpected": "Ocorreu um erro inesperado.",
    "error.signOutFailed": "Falha ao terminar sessão: ",
    "error.enterPrompt": "Introduza as instruções do prompt.",
    "error.readBody": "Falha ao ler o corpo da composição: ",
    "error.insertReply": "Falha ao inserir a resposta: ",
    "error.phishingBlocked":
      "Resposta bloqueada: este e-mail foi sinalizado como possível ameaça de segurança. Reveja o sumário no painel antes de agir.",
    "error.noReplyNeeded": "Este e-mail não requer resposta.",

    // Commands (notifications)
    "notify.signInRequired": "Abra o painel do {app} para iniciar sessão.",
    "notify.authFailed": "Falha no início de sessão: ",
    "notify.generating": "A gerar resposta com IA...",
    "notify.replyFailed": "Falha na resposta: ",
    "notify.settingsError": "Falha ao carregar definições. Tente novamente.",
    "notify.dialogError": "Falha ao abrir o diálogo de instruções: ",
    "notify.unexpectedError": "Ocorreu um erro inesperado no {app}: ",
    "notify.phishingBlocked":
      "Resposta bloqueada: possível phishing detetado. Abra o painel para detalhes.",
    "notify.noReplyNeeded": "Este e-mail não requer resposta.",
  },
};

/**
 * Detect the user's locale from Office or the browser.
 * Returns a normalised key like "pt-PT" or "en-GB".
 */
function detectLocale() {
  let raw = "";

  // 1. URL param (set by parent when opening dialogs)
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has("lang")) raw = params.get("lang");
  } catch {
    /* not in a browser context */
  }

  // 2. Office.context.displayLanguage
  if (!raw) {
    try {
      raw = Office.context.displayLanguage || "";
    } catch {
      /* Office not ready or unavailable */
    }
  }

  // 3. Browser language
  if (!raw) {
    raw = navigator.language || navigator.userLanguage || "";
  }

  // Normalise: "pt", "pt-PT", "pt-BR" → "pt-PT"; anything else → "en-GB"
  if (raw.toLowerCase().startsWith("pt")) return "pt-PT";
  return "en-GB";
}

let currentLocale = "en-GB";
let appName = "AI Assistant";

function initI18n(name) {
  currentLocale = detectLocale();
  if (name) appName = name;
  return currentLocale;
}

function t(key, ...args) {
  const bundle = translations[currentLocale] || translations["en-GB"];
  const value = bundle[key] ?? translations["en-GB"][key] ?? key;
  let out = value.replace(/\{app\}/g, appName);
  args.forEach((arg, i) => {
    out = out.replace(new RegExp(`\\{${i}\\}`, "g"), String(arg));
  });
  return out;
}

function getLocale() {
  return currentLocale;
}

export {initI18n, t, getLocale};
